





































































































































import CommentsForm from './scripts';
export default CommentsForm;
